import { Maps } from "./maps"; // typescript was being dumb and wouldnt recognize "Maps" without the direct reference
import { Doors } from "./doors"; // typescript was being dumb and wouldnt recognize "Maps" without the direct reference
import { Zombie } from "./zombie";
import { Waves } from "./waves";
import { Bullets } from "./bullets";
import { Weapons } from "./weaponPickups";
import { GameObjects } from "phaser";
// TODO reload button
export class Player {
	self: Phaser.Physics.Arcade.Sprite;
	healthMax = 10;
	health = this.healthMax;

	healthTimer = 0;
	recoverTimer = 300;

	points = 0;
	gunText: Phaser.GameObjects.Text;
	pointsText: Phaser.GameObjects.Text;
	healthText: Phaser.GameObjects.Text;
	waveText: Phaser.GameObjects.Text;
	ammoText: Phaser.GameObjects.Text;

	hudPeice1: Phaser.GameObjects.Rectangle;
	hudPeice2: Phaser.GameObjects.Rectangle;
	hudPeice3: Phaser.GameObjects.Rectangle;

	lastFired = 0;
	purchaseDelay = 0;
	lastDir = 1;
	overrideTimer = 0;

	iframes = 0;
	isDead = false;
	deathTimerMax = 80;
	deathTimer = this.deathTimerMax;

	hitstunDuration = 0;
	hitstunImpulse = 0;
	hitstunDirection = 0;

	hitstunFlag = false;

	speed: 160;

	hurtSounds: Phaser.Sound.BaseSound[];
	deathSound: Phaser.Sound.BaseSound;

	constructor() {
		// super();
	}

	preload(context: Phaser.Scene): void {
		// context.load.spritesheet("playerIdle", "assets/Gunner_Black_Idle_extruded.png", {
		// 	frameWidth: 48,
		// 	frameHeight: 48,
		// 	margin:1,
		// 	spacing:2
		// });

		// context.load.spritesheet("playerRun", "assets/Gunner_Black_Run_extruded.png", {
		// 	frameWidth: 48,
		// 	frameHeight: 48,
		// 	margin:1,
		// 	spacing:2
		// });

		// context.load.spritesheet("playerDeath", "assets/Gunner_Black_Death_extruded.png", {
		// 	frameWidth: 48,
		// 	frameHeight: 48,
		// 	margin:1,
		// 	spacing:2
		// });

		context.load.audio("hurt1", ["release_assets/sound/hurt1.wav"]);
		context.load.audio("hurt2", ["release_assets/sound/hurt2.wav"]);
		context.load.audio("hurt3", ["release_assets/sound/hurt3.wav"]);

		context.load.audio("death", ["release_assets/sound/dspdiehi.wav"]);
	}

	create(
		scene: Phaser.Scene,
		zombies: Phaser.Physics.Arcade.Group,
		map: Maps,
		doors: Doors,
		screenX: number,
		screenY: number
	): void {
		this.health = 10;
		this.points = 0;

		this.hudPeice1 = scene.add.rectangle(
			screenX / 10,
			screenY - 35,
			screenX / 5,
			70,
			0x888888,
			0.5
		);
		this.hudPeice1.setScrollFactor(0);
		this.hudPeice2 = scene.add.rectangle(
			screenX / 2,
			screenY - 25,
			(3 * screenX) / 5,
			50,
			0x888888,
			0.5
		);
		this.hudPeice2.setScrollFactor(0);
		this.hudPeice3 = scene.add.rectangle(
			(9 * screenX) / 10,
			screenY - 35,
			screenX / 5,
			70,
			0x888888,
			0.5
		);
		this.hudPeice3.setScrollFactor(0);

		this.pointsText = scene.add.text(screenX - 80, screenY - 30, "0", {
			fontFamily: "Arial",
			fontSize: 24,
			color: "#00ff00"
		});
		this.pointsText.setScrollFactor(0);
		this.healthText = scene.add.text(screenX - 80, screenY - 60, "0", {
			fontFamily: "Arial",
			fontSize: 24,
			color: "#00ff00"
		});
		this.healthText.setScrollFactor(0);

		this.waveText = scene.add.text((4 * screenX) / 9, screenY - 30, "0", {
			fontFamily: "Arial",
			fontSize: 24,
			color: "#00ff00"
		});
		this.waveText.setScrollFactor(0);

		this.gunText = scene.add.text(30, screenY - 60, "0", {
			fontFamily: "Arial",
			fontSize: 24,
			color: "#00ff00"
		});
		this.gunText.setScrollFactor(0);
		this.ammoText = scene.add.text(30, screenY - 30, "0", {
			fontFamily: "Arial",
			fontSize: 24,
			color: "#00ff00"
		});
		this.ammoText.setScrollFactor(0);

		const config: Phaser.Types.Sound.SoundConfig = {
			volume: 0.1
		};

		this.hurtSounds = [
			scene.sound.add("hurt1", config),
			scene.sound.add("hurt2", config),
			scene.sound.add("hurt3", config)
		];
		this.deathSound = scene.sound.add("death", config);

		// this chunk of code finds a random spawn point from objects on the map labelled "Spawn"
		const spawnPoints: TiledObject[] = map.self.filterObjects(
			"Events",
			(obj: Phaser.GameObjects.GameObject): boolean => {
				return obj.name === "Spawn";
			}
		);
		const spawnPoint: TiledObject =
			spawnPoints[Phaser.Math.RND.between(0, spawnPoints.length - 1)];
		// console.log(spawnPoint);
		this.self = scene.physics.add.sprite(spawnPoint.x, spawnPoint.y, "player");

		//  Player physics properties. Give the little guy a slight bounce.
		this.self.setOrigin(0.5, 0.5);
		// this.physics.world.enable(this.player.self);
		this.self.setBounce(0.1);
		// this.self.setCollideWorldBounds(true);
		// Set a decelleration
		// this.self.setDrag(500, 500);
		this.self.setSize(25, 35);
		this.self.setOffset(12, 4);

		scene.physics.add.collider(this.self, map.collision);
		scene.physics.add.collider(this.self, doors.self);
		scene.physics.add.collider(this.self, zombies, this.gotHitZombie, undefined, this);

		//  Our player animations, turning, walking left and walking right.
		const runFrameNames = scene.anims.generateFrameNames("sprites", {
			start: 0,
			end: 5,
			zeroPad: 1,
			prefix: "split/Gunner_Black_Run-",
			suffix: ".png"
		});
		scene.anims.create({ key: "run", frames: runFrameNames, frameRate: 10, repeat: -1 });
		// scene.anims.create({
		// 	key: "run",
		// 	frames: scene.anims.generateFrameNumbers("playerRun", {
		// 		start: 0,
		// 		end: 5
		// 	}),
		// 	frameRate: 10,
		// 	repeat: -1
		// });
		const idleFrameNames = scene.anims.generateFrameNames("sprites", {
			start: 0,
			end: 4,
			zeroPad: 1,
			prefix: "split/Gunner_Black_Idle-",
			suffix: ".png"
		});
		scene.anims.create({ key: "idle", frames: idleFrameNames, frameRate: 10, repeat: -1 });
		// scene.anims.create({
		// 	key: "idle",
		// 	frames: scene.anims.generateFrameNumbers("playerIdle", {
		// 		start: 0,
		// 		end: 4
		// 	}),
		// 	frameRate: 10,
		// 	repeat: -1
		// });
		const deathFrameNames = scene.anims.generateFrameNames("sprites", {
			start: 0,
			end: 7,
			zeroPad: 1,
			prefix: "split/Gunner_Black_Death-",
			suffix: ".png"
		});
		scene.anims.create({ key: "death", frames: deathFrameNames, frameRate: 10, repeat: 0 });
		// scene.anims.create({
		// 	key: "death",
		// 	frames: scene.anims.generateFrameNumbers("playerDeath", {
		// 		start: 0,
		// 		end: 7
		// 	}),
		// 	frameRate: 10,
		// 	repeat: 0
		// });
		const hurtFrameNames = scene.anims.generateFrameNames("sprites", {
			start: 0,
			end: 3,
			zeroPad: 1,
			prefix: "split/Gunner_Black_Hurt-",
			suffix: ".png"
		});
		scene.anims.create({ key: "hurt", frames: hurtFrameNames, frameRate: 10, repeat: 0 });
	}

	update(
		time: number,
		delta: number,
		scene: Phaser.Scene,
		keyboardInput: KeyboardInput,
		activePointer: Phaser.Input.Pointer,
		doors: Doors,
		wave: Waves,
		ammo: Bullets,
		pickups: Weapons
	): void {
		this.pointsText.setText(`¥${this.points}`);
		this.healthText.setText(`♥ [${this.health}]`);

		const currentWave: number = wave.getCurrentWaveNumber();
		if (wave.getTimeUntilNextWave(time) > 0) {
			// this.waveText.setText(`Break: ${wave.getTimeUntilNextWave(time).toFixed(1)}`);
		} else {
			this.waveText.setText(`Wave: ${currentWave}`);
		}

		const currentAmmo: number = ammo.getAmmoCount();
		this.ammoText.setText(`${currentAmmo}`);

		const currentGun: string = ammo.getCurrentGun();
		this.gunText.setText(`[${currentGun}]`);

		if (activePointer.isDown) {
			this.overrideTimer = 30;
		}

		if (this.hitstunDuration > 0) {
			// Shove the player in a direction...
			this.self.setVelocityX(this.hitstunImpulse * Math.cos(this.hitstunDirection));
			this.self.setVelocityY(this.hitstunImpulse * Math.sin(this.hitstunDirection));

			if (this.health > 0) {
				this.hitstunDuration -= 1;
			}

			this.hitstunImpulse *= 0.9;
		} else if (this.health > 0) {
			if (keyboardInput.left?.isDown) {
				this.self.setVelocityX(-160);

				this.self.flipX = true;
				this.self.anims.play("run", true);
				this.lastDir = -1;
			} else if (keyboardInput.right?.isDown) {
				this.self.setVelocityX(160);

				this.self.flipX = false;
				this.self.anims.play("run", true);
				this.lastDir = 1;
			} else {
				this.self.setVelocityX(0);
			}

			if (keyboardInput.up?.isDown) {
				this.self.setVelocityY(-160);

				if (this.lastDir === -1) {
					this.self.flipX = true;
				} else if (this.lastDir === 1) {
					this.self.flipX = false;
				}
				this.self.anims.play("run", true);
			} else if (keyboardInput.down?.isDown) {
				this.self.setVelocityY(160);

				if (this.lastDir === -1) {
					this.self.flipX = true;
				} else if (this.lastDir === 1) {
					this.self.flipX = false;
				}
				this.self.anims.play("run", true);
			} else {
				this.self.setVelocityY(0);
			}

			if (
				!keyboardInput.up?.isDown &&
				!keyboardInput.down?.isDown &&
				!keyboardInput.left?.isDown &&
				!keyboardInput.right?.isDown
			) {
				this.self.anims.play("idle", true);
			}

			if (this.overrideTimer > 0) {
				this.overrideTimer -= 1;

				activePointer.updateWorldPoint(scene.cameras.main);
				const dx: number = activePointer.worldX - this.self.x;

				this.self.flipX = dx < 0;
			}

			if (keyboardInput.space.isDown && this.purchaseDelay + 500 < time) {
				this.purchaseDelay = time;
				if (doors.afford(this.points)) {
					this.points = this.points - doors.buy();
				}
				if (pickups.afford(this.points)) {
					this.points = this.points - pickups.buy(wave);
				}
			}
		}
		if (this.health <= 0) {
			// We are dead here
			if (this.deathTimer <= 0) {
				this.isDead = true;
			} else {
				this.deathTimer -= 1;
				this.self.setAlpha((2 * this.deathTimer) / this.deathTimerMax);
			}

			if (this.hitstunDuration <= 0) {
				// If the hitstun timer is not active during this, set our velocity to zero so we do not get shoved more...
				this.self.setVelocityY(0);
				this.self.setVelocityX(0);
			}
		}

		// if (keyboardInput.up?.isDown && this.self.body.touching.down) {
		// 	this.self.setVelocityY(-330);
		// }

		// Iterate the Iframes
		if (this.iframes > 0) {
			this.iframes -= 1;
		}

		// Slowly recover health if we are not hit for a long enought period of time...
		if (this.healthTimer > this.recoverTimer && this.health < this.healthMax) {
			this.health += 1;
			this.healthTimer = 0;
		} else if (this.health < this.healthMax) {
			this.healthTimer += 1;
		} else {
			this.healthTimer = 0;
		}
	}

	setHitstun(duration: number, force: number, dir: number): void {
		this.hitstunFlag = true;

		// Small randomization to add some flair...

		// We also modify this
		this.hitstunImpulse = force * Phaser.Math.RND.realInRange(0.9, 1.1);
		this.hitstunDuration = duration * Phaser.Math.RND.realInRange(0.9, 1.1);
		this.hitstunDirection = dir;
	}

	gotHitZombie(player: Phaser.Physics.Arcade.Sprite, zombie: Zombie): void {
		// If we are not currently invincible... Register a hit
		if (this.iframes <= 0 && zombie.active === true && zombie.health > 0 && this.health > 0) {
			this.iframes = 60;

			this.health -= zombie.damage;
			this.healthTimer = 0;

			const dir: number = Math.atan2(-zombie.y + this.self.y, -zombie.x + this.self.x);
			// const dir2: number = Math.atan2(zombie.y-this.self.y, zombie.x-this.self.x);

			this.setHitstun(10, 400, dir);
			// zombie.setHitstun(10, 400, dir2);

			if (this.health <= 0) {
				// Play a death sound
				this.deathSound.play();
				// this... SHOULD be the only animation call the moment we die...
				this.self.anims.play("death", true, 0);
			} else {
				const hurtSound = Phaser.Utils.Array.GetRandom(this.hurtSounds);
				this.self.anims.play("hurt", true, 0);
				hurtSound.play();

				// We disable the movement during the hitstun, so this SHOULD be called and stay on till movement returns...
				// this.self.anims.play("idle", true);
			}
		}
	}
}
